import { MutableRefObject, Ref } from 'react'

export function setRef<T>(ref: Ref<T>, value: T | null): void {
  if (!ref) {
    return
  } else if (typeof ref === 'function') {
    ref(value)
  } else {
    const mutable = ref as MutableRefObject<T | null>
    mutable.current = value
  }
}
